/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import { LinearGradient } from './LinearGradient';

export var gradientTypes = {
  linearGradient: LinearGradient
};

export * from './LinearGradient';


//////////////////
// WEBPACK FOOTER
// ../nivo/es/components/defs/gradients/index.js
// module id = 218
// module chunks = 0